module.exports = __webpack_public_path__ + "img/CF_2AA.9879cbb8.jpg";